import {
  GetCategoriesCpg_CachedQuery,
  GetCategoriesCpg_CachedQueryVariables
} from '@data/__generated__/types.main'
import isServerSide from '@helpers/misc/isServerSide'
import {useApolloQuery} from 'apollo-hooks'
import gql from 'graphql-tag'

export interface Props {
  websiteId: string
}

export default function useCategoriesCPG({websiteId}: Props) {
  const {categories} = useApolloQuery<
    GetCategoriesCpg_CachedQuery,
    GetCategoriesCpg_CachedQueryVariables
  >({
    query: gql`
      query getCategoriesCPG_cached($websiteId: ID) {
        categories(websiteId: $websiteId) {
          items {
            _id
            name
            subCategories {
              items {
                _id
                name
              }
            }
            products {
              _id
            }
          }
        }
      }
    `,
    variables: {websiteId},
    omit: isServerSide()
  })

  return {categoriesCPG: categories}
}
